// scrolllock for all devices(needed primary for ios). Is often needed for the mobile menü
$.scrollLock = (function scrollLockClosure() {
    const $html = $('html');
    // State: unlocked by default
    let locked = false;
    // State: scroll to revert to
    let prevScroll = {
        scrollLeft: $(window).scrollLeft(),
        scrollTop: $(window).scrollTop(),
    };
    // State: styles to revert to
    const prevStyles = {};
    const lockStyles = {
        'overflow-y': 'scroll',
        position: 'fixed',
        width: '100%',
    };

    // Save context's inline styles in cache
    function saveStyles() {
        const styleAttr = $html.attr('style');
        let styleStrs = [];
        const styleHash = {};

        if (!styleAttr) {
            return;
        }

        styleStrs = styleAttr.split(/;\s/);

        $.each(styleStrs, (styleString) => {
            if (!styleString) {
                return;
            }

            const keyValue = styleString.split(/\s:\s/);

            if (keyValue.length < 2) {
                return;
            }
            // eslint-disable-next-line prefer-destructuring
            styleHash[keyValue[0]] = keyValue[1];
        });

        $.extend(prevStyles, styleHash);
    }

    // Instantiate cache in case someone tries to unlock before locking
    saveStyles();

    function lock() {
        const appliedLock = {};

        // Duplicate execution will break DOM statefulness
        if (locked) {
            return;
        }

        // Save scroll state...
        prevScroll = {
            scrollLeft: $(window).scrollLeft(),
            scrollTop: $(window).scrollTop(),
        };

        // ...and styles
        saveStyles();

        // Compose our applied CSS
        $.extend(appliedLock, lockStyles, {
            // And apply scroll state as styles
            left: `${-prevScroll.scrollLeft}px`,
            top: `${-prevScroll.scrollTop}px`,
        });

        // Then lock styles...
        $html.css(appliedLock);

        // ...and scroll state
        $(window)
            .scrollLeft(0)
            .scrollTop(0);

        locked = true;
    }

    function unlock() {
        // Duplicate execution will break DOM statefulness
        if (!locked) {
            return;
        }

        // Revert styles
        $html.attr('style', $('<x>').css(prevStyles).attr('style') || '');

        // Revert scroll values
        $(window)
            .scrollLeft(prevScroll.scrollLeft)
            .scrollTop(prevScroll.scrollTop);

        locked = false;
    }

    return function scrollLock(on) {
        // If an argument is passed, lock or unlock depending on truthiness
        if (arguments.length) {
            if (on) {
                lock();
            } else {
                unlock();
            }
        } else if (locked) {
            // Otherwise, toggle
            unlock();
        } else {
            lock();
        }
    };
}());
